import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const MyChart = ({ dashboardList, role }) => {
  const [chartData, setChartData] = useState([]);

  const filtervalue =
    role.role_id === 1
      ? chartData
      : chartData.filter((item) =>
          ["Event", "Schedule", "Live"].includes(item.name)
        );
  useEffect(() => {
    if (!dashboardList || Object.keys(dashboardList).length === 0) {
      return;
    }
    const transformedData = Object.keys(dashboardList).map((key) => ({
      name: key.charAt(0).toUpperCase() + key.slice(1),
      value: dashboardList[key],
    }));
    setChartData(transformedData);
  }, [dashboardList]);

  return (
    <div style={{ width: "100%", height: "500px", backgroundColor: "white" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={filtervalue}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#00aeef"
            strokeWidth={2}
            dot={{
              fill: "#00aeef",
              stroke: "#00aeef",
              r: 4,
            }}
            activeDot={{
              r: 6,
              fill: "#00aeef",
              stroke: "#fff",
              strokeWidth: 2,
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MyChart;
